import {
  TransitionProps as MantineTransitionProps,
  Transition as MantineTransition,
} from '@mantine/core';

export type TransitionProps = MantineTransitionProps;

export const Transition = (props: TransitionProps) => {
  return <MantineTransition {...props} />;
};

Transition.displayName = 'Transition';
